// extracted by mini-css-extract-plugin
module.exports = {"product-search-refinement-root":"ProductSearchRefinementRoot_product-search-refinement-root__0eL3G"};